<template>
    <div>

        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
         </div>

         <div class="formulario">
              <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                  <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Endereço residencial'" :TipoCliente="'Pessoa Física'" :Sessao="'Endereço'" :SubSessao="'Endereço residencial'"/>
                </div>
                <div class="camposAgrupamentoFormulario">

                  <div class="row">
                    <div class="label__field" style="width: 40%">
                      <label class="label" for="nome">CEP*</label>
                      <input class="field" type="text" id="cep" placeholder="" v-model="localPF.Cep" @change="validarCep">
                       <p v-if="camposObrigatorios.erroEnderecoCep" class="erro">
                                Campo obrigatório
                            </p>
                    </div>

                      <div class="label__field" style="width: 40%; margin-top: 35px;">
                        <a target="_blank" href="https://buscacepinter.correios.com.br/app/endereco/index.php">Não sei o CEP</a>
                      </div>

                  </div>


                  <div class="row">
                    <div class="label__field" style="width: 47%">
                      <label class="label" for="nome">Endereço*</label>
                      <input class="field" type="text" :disabled="isDisabledEndereco" id="endereco" v-model="localPF.Logradouro" placeholder="">

                    </div>

                     <div class="label__field" style="width: 30%">
                      <label class="label" for="nome">Número*</label>
                      <input class="field" type="text" id="numero"  @change="salvarAlteracoesLocalmente" v-model="localPF.LogradouroNumero" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoNumero" class="erro">
                                Campo obrigatório
                            </p>
                    </div>

                  </div>

                    <div class="row">
                    <div class="label__field" style="width: 47%">
                      <label class="label" for="nome">Complemento</label>
                      <input class="field" type="text" @change="salvarAlteracoesLocalmente" v-model="localPF.LogradouroComplemento" id="complemento" placeholder="">

                    </div>

                     <div class="label__field" style="width: 30%">
                      <label class="label" for="nome">Bairro*</label>
                      <input class="field" type="text" :disabled="isDisabledEndereco" v-model="localPF.Bairro" id="bairro" placeholder="">
                    </div>

                  </div>
                  
                   <div class="row">
                    <div class="label__field" style="width: 25%">
                      <label class="label" for="nome">Cidade</label>
                      <input class="field" type="text" :disabled="isDisabledEndereco" v-model="localPF.Cidade" id="cidade" placeholder="">

                    </div>

                     <div class="label__field" style="width: 25%">
                      <label class="label" for="nome">UF*</label>
                      <input class="field" type="text" :disabled="isDisabledEndereco" id="uf" v-model="localPF.Uf" placeholder="">
                    </div>

                     <div class="label__field" style="width: 25%">
                      <label class="label" for="nome">País*</label>
                      <input class="field" type="text" :disabled="isDisabledEndereco" id="pais" v-model="localPF.Pais" placeholder="">
                    </div>

                  </div>


                                     <div class="row">
                    <div class="label__field" style="width: 50%">
                      <label class="label" for="nome">Esse endereço é o mesmo de correspondência?*</label>
                                           <div class="radio">
                                            <input
                                                type="radio"
                                                id="1"
                                                value="1"
                                                name="EnderecoCorrespondencia"
                                                class="field__radio"
                                                v-model="localPF.EnderecoCorrespondencia"
                                                @change="salvarAlteracoesLocalmenteLimpandoEnderecoCorrespondencia"                                            

                                            />
                                            <label
                                                for="sim"
                                                class="label__radio"
                                            >
                                                Sim
                                            </label>

                                            <input
                                                type="radio"
                                                id="2"
                                                value="2"
                                                name="EnderecoCorrespondencia"
                                                class="field__radio"
                                                v-model="localPF.EnderecoCorrespondencia"
                                                @change="salvarAlteracoesLocalmente"    
                                            />
                                            <label
                                                for="nao"
                                                class="label__radio"
                                            >
                                                Não
                                            </label>
                                           </div>
                    </div>

                                     </div>


                </div>
              </div>
              
              <div class="agrupamentoFormulario" v-if="localPF.EnderecoCorrespondencia == 2">
                <div class="categoriaAgrupamentoFormulario">
                  <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Endereço correspondência'" :TipoCliente="'Pessoa Física'" :Sessao="'Endereço'" :SubSessao="'Endereço correspondência'"/>
                </div>
                <div class="camposAgrupamentoFormulario">

                  <div class="row">
                    <div class="label__field" style="width: 40%">
                      <label class="label" for="nome">CEP*</label>
                      <input class="field" type="text" id="cep" placeholder="" v-model="localPF.CepOutro" @change="validarCepOutro">
                      <p v-if="camposObrigatorios.erroEnderecoOutroCep" class="erro">
                         Campo obrigatório
                      </p>
                    </div>

                      <div class="label__field" style="width: 40%; margin-top: 35px;">
                        <a target="_blank" href="https://buscacepinter.correios.com.br/app/endereco/index.php">Não sei o CEP</a>
                      </div>

                  </div>


                  <div class="row">
                    <div class="label__field" style="width: 47%">
                      <label class="label" for="nome">Endereço*</label>
                      <input class="field" type="text" :disabled="isDisabledEnderecoOutro" id="endereco" v-model="localPF.LogradouroOutro" placeholder="">
                    </div>

                     <div class="label__field" style="width: 30%">
                      <label class="label" for="nome">Número*</label>
                      <input class="field" type="text" id="numero"  @change="salvarAlteracoesLocalmente" v-model="localPF.LogradouroNumeroOutro" placeholder="">
                      <p v-if="camposObrigatorios.erroEnderecoOutroNumero" class="erro">
                        Campo obrigatório
                      </p>
                    </div>

                  </div>

                    <div class="row">
                    <div class="label__field" style="width: 47%">
                      <label class="label" for="nome">Complemento</label>
                      <input class="field" type="text" @change="salvarAlteracoesLocalmente" v-model="localPF.LogradouroComplementoOutro" id="complemento" placeholder="">

                    </div>

                     <div class="label__field" style="width: 30%">
                      <label class="label" for="nome">Bairro*</label>
                      <input class="field" type="text" :disabled="isDisabledEnderecoOutro" v-model="localPF.BairroOutro" id="bairro" placeholder="">
                    </div>

                  </div>
                  
                   <div class="row">
                    <div class="label__field" style="width: 25%">
                      <label class="label" for="nome">Cidade</label>
                      <input class="field" type="text" :disabled="isDisabledEnderecoOutro" v-model="localPF.CidadeOutro" id="cidade" placeholder="">

                    </div>

                     <div class="label__field" style="width: 25%">
                      <label class="label" for="nome">UF*</label>
                      <input class="field" type="text" :disabled="isDisabledEnderecoOutro" id="uf" v-model="localPF.UfOutro" placeholder="">
                    </div>

                     <div class="label__field" style="width: 25%">
                      <label class="label" for="nome">País*</label>
                      <input class="field" type="text" :disabled="isDisabledEnderecoOutro" id="pais" v-model="localPF.PaisOutro" placeholder="">
                    </div>

                  </div>


                </div>
              </div>

              <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                  <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Endereço comercial'" :TipoCliente="'Pessoa Física'" :Sessao="'Endereço'" :SubSessao="'Endereço comercial'"/>
                </div>
                <div class="camposAgrupamentoFormulario">

                  <div class="row">
                    <div class="label__field" style="width: 40%">
                      <label class="label" for="nome">CEP</label>
                      <input class="field" type="text" id="cep" placeholder="" v-model="localPF.EnderecoComercialCep" @change="validarCepComercial">
                    </div>

                      <div class="label__field" style="width: 40%; margin-top: 35px;">
                        <a target="_blank" href="https://buscacepinter.correios.com.br/app/endereco/index.php">Não sei o CEP</a>
                      </div>

                  </div>


                  <div class="row">
                    <div class="label__field" style="width: 47%">
                      <label class="label" for="nome">Endereço</label>
                      <input class="field" type="text" :disabled="isDisabledEnderecoComercial" id="endereco" v-model="localPF.EnderecoComercial" placeholder="">

                    </div>

                     <div class="label__field" style="width: 30%">
                      <label class="label" for="nome">Número</label>
                      <input class="field" type="text" id="numero"  @change="salvarAlteracoesLocalmente" v-model="localPF.EnderecoComercialNumero" placeholder="">

                    </div>

                  </div>

                    <div class="row">
                    <div class="label__field" style="width: 47%">
                      <label class="label" for="nome">Complemento</label>
                      <input class="field" type="text" @change="salvarAlteracoesLocalmente" v-model="localPF.EnderecoComercialComplemento" id="complemento" placeholder="">

                    </div>

                     <div class="label__field" style="width: 30%">
                      <label class="label" for="nome">Bairro</label>
                      <input class="field" type="text" :disabled="isDisabledEnderecoComercial" v-model="localPF.EnderecoComercialBairro" id="bairro" placeholder="">
                    </div>

                  </div>
                  
                   <div class="row">
                    <div class="label__field" style="width: 25%">
                      <label class="label" for="nome">Cidade</label>
                      <input class="field" type="text" :disabled="isDisabledEnderecoComercial" v-model="localPF.EnderecoComercialCidade" id="cidade" placeholder="">

                    </div>

                     <div class="label__field" style="width: 25%">
                      <label class="label" for="nome">UF</label>
                      <input class="field" type="text" :disabled="isDisabledEnderecoComercial" id="uf" v-model="localPF.EnderecoComercialEstado" placeholder="">
                    </div>

                     <div class="label__field" style="width: 25%">
                      <label class="label" for="nome">País</label>
                      <input class="field" type="text" :disabled="isDisabledEnderecoComercial" id="pais" v-model="localPF.EnderecoComercialPais" placeholder="">
                    </div>

                  </div>


                </div>
              </div>

         </div>

          <div class="footerFormulario">

            <div class="buttonsAcoes">
              <button class="btnDefault" @click="salvarInformacoes" v-if="this.Edicao != true">Salvar e continuar depois</button>
              <button class="btnDefault" @click="salvarInformacoes" v-if="this.Edicao == true">Salvar</button>
              <button class="btnBlue" v-if="!Edicao" @click="proximaEtapa">Avançar</button>
            </div>

          </div>

    </div>
</template>


<script>

import { mapGetters } from 'vuex';
import viacep from '@/api/viacep';
import LabelDisclaimer  from '../Utilitarios/Disclaimer/LabelDisclaimer.vue'

export default {
      name: 'CadastroPF_Endereco',
      props: ['informacoesBasicas', 'Edicao'],
            components: {LabelDisclaimer},
      computed: {
        ...mapGetters({
            user: 'auth/user',
            etapaCadastro: 'GET_ETAPA_CADASTRO',
            infoBasicas: 'GET_PF_INFO_BASICAS',
        }),
    },
    data() {
       return {
        camposObrigatorios: {
            erroEnderecoCep: false,
            erroEnderecoNumero: false,
            erroEnderecoOutroCep: false,
            erroEnderecoOutroNumero: false,
        },
        isDisabledEndereco: true,
        isDisabledEnderecoComercial: true,
        isDisabledEnderecoOutro: true,
        localPF: this.informacoesBasicas,
        permitirAvancar: false
      }
    },
    mounted(){
      if(this.localPF != null){
        this.localPF.EnderecoCorrespondencia = this.informacoesBasicas.CepOutro != '' && this.localPF.CepOutro != null ? 2 : 1;
      }
      this.validarFormulario();
    },
    methods: {
      salvarAlteracoesLocalmenteLimpandoEnderecoCorrespondencia(){

          this.localPF.LogradouroOutro = null;
          this.localPF.BairroOutro = null;
          this.localPF.CidadeOutro = null;
          this.localPF.UfOutro = null;
          this.localPF.PaisOutro = null;
          this.localPF.CepOutro = null;

          this.salvarAlteracoesLocalmente();
      },
      proximaEtapa(){
        this.validarFormulario(true);
        
        if(this.permitirAvancar)
        {
          this.$store.commit('SET_ETAPA_CADASTRO', 5);
          this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
          this.salvarInformacoes();
        }
      },
      salvarInformacoes(){
        this.$store.commit('SET_PF_SALVAR_INFO', true);
      },
      salvarAlteracoesLocalmente(){
        this.$store.commit('SET_PF_SALVAR_INFO_ENDERECO', this.localPF);
        this.validarFormulario(false);
      },
      validarFormulario(submeter)  {
        this.permitirAvancar = true;
        var nomeDoCampo = '';

        this.camposObrigatorios = {
            erroEnderecoCep: false,
            erroEnderecoNumero: false,
            erroEnderecoOutroCep: false,
            erroEnderecoOutroNumero: false,
        };
        

          if (!this.localPF.Cep) {

            if (submeter && this.permitirAvancar) {
              this.camposObrigatorios.erroEnderecoCep = true;
              nomeDoCampo = 'CEP do Endereço Principal';
            }

            this.permitirAvancar = false;
          }

          if (!this.localPF.LogradouroNumero) {

            if (submeter && this.permitirAvancar) {
              this.camposObrigatorios.erroEnderecoNumero = true;
              nomeDoCampo = 'Número do Endereço Principal';
            }

            this.permitirAvancar = false;
          }

          if (!this.localPF.CepOutro && this.localPF.EnderecoCorrespondencia == 2) {

            if (submeter && this.permitirAvancar) {
              this.camposObrigatorios.erroEnderecoOutroCep = true;
              nomeDoCampo = 'CEP do Endereço Correspondência';
            }

            this.permitirAvancar = false;
          }

          if (!this.localPF.LogradouroNumeroOutro  && (this.localPF.CepOutro && this.localPF.EnderecoCorrespondencia == 2)) {

            if (submeter && this.permitirAvancar) {
              this.camposObrigatorios.erroEnderecoOutroNumero = true;
              nomeDoCampo = 'Número do Endereço Correspondência';
            }

            this.permitirAvancar = false;
          }

          if(nomeDoCampo != '' && submeter){
          this.$swal({
               icon: 'warning',
               title: 'Oops...',
               text: `O campo `+ nomeDoCampo +` não foi informado, preencha a informação para avançar`,
           });
          }

      },
      async validarCep() {
            var cepFormatado = this.localPF.Cep.replace(/\D/g, '');
            this.localPF.Cep = cepFormatado;
            if(cepFormatado.length != 8)
            {
                this.$swal({
                  icon: 'error',
                  title: 'Oops...',
                  text: `CEP informado está fora do padrão`,
                });

                this.localPF.Logradouro = null;
                this.localPF.Bairro = null;
                this.localPF.Cidade = null;
                this.localPF.Uf = null;
                this.localPF.Pais = null;
                this.localPF.Cep = null;
                this.isDisabledEndereco = true; 
            }
            else
            {

                const { data } = await viacep.get(`/ws/${this.localPF.Cep}/json/`);

                if (data.erro) {

                  this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `CEP informado não foi localizado, preencha os campos manualmente`,
                  });

                  this.isDisabledEndereco = false; 

              } else {

                  this.erro = false;
                  this.localPF.Logradouro = data.logradouro;
                  this.localPF.Bairro = data.bairro;
                  this.localPF.Cidade = data.localidade;
                  this.localPF.Uf = data.uf;
                  this.localPF.Pais = 'Brasil';
                  this.salvarAlteracoesLocalmente();

                  if (this.localPF.Logradouro === '' || this.localPF.Bairro == '') {
                    this.isDisabledEndereco = false; 
                  }else{
                    this.isDisabledEndereco = true; 
                  }

              }
            }
      },
      
      async validarCepComercial() {
            var cepFormatado = this.localPF.EnderecoComercialCep.replace(/\D/g, '');
            this.localPF.EnderecoComercialCep = cepFormatado;
            if(cepFormatado.length != 8)
            {
                this.$swal({
                  icon: 'error',
                  title: 'Oops...',
                  text: `CEP informado está fora do padrão`,
                });

                this.localPF.EnderecoComercial = null;
                this.localPF.EnderecoComercialBairro = null;
                this.localPF.EnderecoComercialCidade = null;
                this.localPF.EnderecoComercialEstado = null;
                this.localPF.EnderecoComercialPais = null;
                this.localPF.EnderecoComercialCep = null;
                this.isDisabledEnderecoComercial = true; 
            }
            else
            {

                const { data } = await viacep.get(`/ws/${this.localPF.EnderecoComercialCep}/json/`);

                if (data.erro) {

                  this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `CEP informado não foi localizado, preencha os campos manualmente`,
                  });

                  this.isDisabledEnderecoComercial = true; 

              } else {

                  this.erro = false;
                  this.localPF.EnderecoComercial = data.logradouro;
                  this.localPF.EnderecoComercialBairro = data.bairro;
                  this.localPF.EnderecoComercialCidade = data.localidade;
                  this.localPF.EnderecoComercialEstado = data.uf;
                  this.localPF.EnderecoComercialPais = 'Brasil';
                  this.salvarAlteracoesLocalmente();

                  if (this.localPF.EnderecoComercial === '' || this.localPF.EnderecoComercialBairro == '') {
                    this.isDisabledEnderecoComercial = false; 
                  }else{
                    this.isDisabledEnderecoComercial = true; 
                  }

              }
            }
      },
      async validarCepOutro() {
            var cepFormatado = this.localPF.CepOutro.replace(/\D/g, '');
            this.localPF.CepOutro = cepFormatado;
            if(cepFormatado.length != 8)
            {
                this.$swal({
                  icon: 'error',
                  title: 'Oops...',
                  text: `CEP informado está fora do padrão`,
                });

                this.localPF.LogradouroOutro = null;
                this.localPF.BairroOutro = null;
                this.localPF.CidadeOutro = null;
                this.localPF.UfOutro = null;
                this.localPF.PaisOutro = null;
                this.localPF.CepOutro = null;
                this.isDisabledEnderecoOutro = true; 
            }
            else
            {

                const { data } = await viacep.get(`/ws/${this.localPF.CepOutro}/json/`);

                if (data.erro) {

                  this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `CEP informado não foi localizado, preencha os campos manualmente`,
                  });

                  this.isDisabledEnderecoOutro = true; 

              } else {

                  this.erro = false;
                  this.localPF.LogradouroOutro = data.logradouro;
                  this.localPF.BairroOutro = data.bairro;
                  this.localPF.CidadeOutro = data.localidade;
                  this.localPF.UfOutro = data.uf;
                  this.localPF.PaisOutro = 'Brasil';
                  this.salvarAlteracoesLocalmente();


                  if (this.localPF.LogradouroOutro === '' || this.localPF.BairroOutro == '') {
                    this.isDisabledEnderecoComercial = false; 
                  }else{
                    this.isDisabledEnderecoComercial = true; 
                  }


              }
            }
      },
    }
}

</script>


<style lang="scss" scoped>

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');



.formulario{
  width: 100%;
}

.agrupamentoFormulario{
  width: 100%;
  display: inline-flex;
  margin-top: 10px;
}

.categoriaAgrupamentoFormulario{
  width: 13%;
  margin-right: 15px;
  font-family: 'Inter', sans-serif; /* Fonte Inter */

  span{
    font-weight: 400 !important;
    font-size: 13px;
    color: #667085;
  }

}

.label__field{
  padding-right: 30px;
}

.camposAgrupamentoFormulario{
  width: 90%;

  .row{
    width: 100%;
    display: inline-flex;
    gap: 8px;
    margin-bottom: 10px;
  }

                  .accept {
                    display: inline-flex;

                    &:checked {
                      +label {
                            &:before {
                                background: white;
                                border: 1px solid black;
                                transition: background 0.3s;
                            }
                        }

                        +label {
                            &::after {
                                opacity: 1;
                                transition: all;
                                background: transparent;
                            }
                        }
                    }
                }

 .radio {
                display: flex;
                align-items: center;
                margin-right: 25px;

                @media (max-width: 768px) {
                    margin-right: 0;
                    margin-bottom: 20px;
                }

                .field__radio {
                    width: 20px;
                    height: 20px;
                }

                .fieldInRadio{
    border-radius: 8px; /* Raio de borda */
    border: 1px solid #D0D5DD; /* Borda */
    padding: 10px 14px; /* Preenchimento interno */
    background-color: #F9FAFB; /* Cor de fundo */
    width: 55%;
                }

                .label__radio {
                    margin-left: 5px;
                    margin-right: 40px;
                    margin-top: 5px;
                }
            }

select{
  width: 105% !important;
}


label {
    font-family: 'Inter', sans-serif; /* Fonte Inter */
    font-weight: 500; /* Peso médio */
    font-size: 14px; /* Tamanho da fonte */
    line-height: 20px; /* Altura da linha */
    color: #344054; /* Cor */
    display: block; /* Garante que a label fique acima do input */
    margin-bottom: 8px; /* Espaçamento entre a label e o input abaixo dela */
}

}





.title{

  border-bottom: 1px solid #EAECF0;

  h3{
    margin-top: 50px;
    color: #101828;
    font-weight: 500;
    font-family: 'Inter', sans-serif;
    
  }

  h5{
    margin-top: 5px;
    margin-block-start: 0;
    color: #667085;
    font-weight: 400;
    font-family: 'Inter', sans-serif;
  }
}


</style>